export const BBClientToDb = ({
    ratio,
    margin,
    boundaryWidth,
    boundaryHeight,
}) => box => {
    const { start, end, id, tempId } = box;
    const [x, y] = start;
    const [w, h] = end;

    // Check if annotations are inside boundaries
    const maxX = boundaryWidth - margin;
    const maxY = boundaryHeight;

    let topLeftX;
    let topLeftY;
    let width;
    let height;

    if (x < margin) {
        topLeftX = 0;
    } else if (x > maxX) {
        topLeftX = Math.floor(maxX * ratio);
    } else {
        topLeftX = Math.floor((x - margin) * ratio);
    }

    if (w + x < margin) {
        width = 0;
    } else if (w + x > maxX) {
        if (x > maxX) {
            width = 0;
        } else if (x < margin) {
            width = (maxX - margin) * ratio;
        } else {
            width = (maxX - x) * ratio;
        }
    } else {
        if (x < margin) {
            width = (w - margin + x) * ratio;
        } else {
            width = w * ratio;
        }
    }

    if (y < 0) {
        topLeftY = 0;
    } else if (y > maxY) {
        topLeftY = Math.floor(maxY * ratio);
    } else {
        topLeftY = Math.floor(y * ratio);
    }

    if (h + y < 0) {
        height = 0;
    } else if (h + y > maxY) {
        if (y > maxY) {
            height = 0;
        } else if (y < 0) {
            height = maxY * ratio;
        } else {
            height = (maxY - y) * ratio;
        }
    } else {
        if (y < 0) {
            height = (h + y) * ratio;
        } else {
            height = h * ratio;
        }
    }

    return {
        id,
        tempId,
        topLeftX,
        topLeftY,
        width,
        height,
    };
};

export const BBDbToClient = ({ ratio, margin }) => box => {
    const { topLeftX, topLeftY, width, height, id, tempId } = box;
    if (!ratio) return { start: [], end: [] };
    const updatedStartX = topLeftX / ratio + margin;
    const start = [updatedStartX, topLeftY / ratio];
    const end = [width / ratio, height / ratio];
    return { start, end, id, tempId };
};

export const getLambdaURL = (imgURL, boxes) => {
    let lambaURL = `https://yr8fguzkid.execute-api.us-east-1.amazonaws.com/prod/placementOverlayGenerator?img=${imgURL}`;
    const coordsParams = boxes.reduce(
        (acc, b) => {
            const { topLeftX: left, topLeftY: top, width, height } = b;
            acc.left.push(left);
            acc.top.push(top);
            acc.width.push(width);
            acc.height.push(height);
            return acc;
        },
        {
            top: [],
            left: [],
            width: [],
            height: [],
        },
    );
    const coordsQueryString = Object.entries(coordsParams).reduce(
        (acc, [k, v]) => {
            acc += `&${k}=${v}`;
            return acc;
        },
        '',
    );
    lambaURL = `${lambaURL}${coordsQueryString}`;
    return lambaURL;
};

export const getTempId = b => {
    const { start, end } = b;
    const [startX, startY] = start;
    const [endX, endY] = end;
    return `${Math.floor(startX)}_${Math.floor(startY)}_${Math.floor(
        endX,
    )}_${Math.floor(endY)}`;
};

export const addTempId = b => {
    return {
        ...b,
        tempId: getTempId(b),
    };
};

export const getImageTransformations = img => {
    if (!img) return {};
    const objectContainRatio = img.naturalWidth / img.naturalHeight;
    const heightRatio = img.naturalHeight / img.offsetHeight;
    const widthRatio = img.naturalWidth / img.offsetWidth;
    let ratio = 1;
    let margin = 0;
    let height = img.naturalHeight;
    let width = img.naturalWidth;
    if (heightRatio >= widthRatio) {
        height = img.offsetHeight;
        width = height * objectContainRatio;
        ratio = img.naturalHeight / height;
        margin = (img.offsetWidth - width) / 2;
    } else {
        width = img.offsetWidth;
        height = width / objectContainRatio;
        ratio = img.naturalHeight / height;
        margin = 0;
    }

    return {
        margin,
        ratio,
        boundaryWidth: img.offsetWidth,
        boundaryHeight: img.offsetHeight,
        width,
        height,
    };
};
